import { TZDate } from '@date-fns/tz';

export const TIME_ZONE = 'Europe/Stockholm';
/** Gap enforced between two bookings in the same room. Also hard-coded in SQL (buffered()). */
export const BUFFER_MINUTES = 15;
/** Booking times snap to this step. Also hard-coded in SQL (on_quarter()). */
export const STEP_MINUTES = 15;

/** A wall-clock time in Swedish time as an absolute Date. month is 1-12. */
export function stockholm(year: number, month: number, day: number, hour = 0, minute = 0): Date {
  return new Date(new TZDate(year, month - 1, day, hour, minute, 0, TIME_ZONE).getTime());
}

/** The wall-clock parts of an instant in Swedish time. */
export function stockholmParts(d: Date) {
  const z = new TZDate(d.getTime(), TIME_ZONE);
  return {
    year: z.getFullYear(),
    month: z.getMonth() + 1,
    day: z.getDate(),
    hour: z.getHours(),
    minute: z.getMinutes(),
    weekday: (z.getDay() + 6) % 7, // 0 = Monday
  };
}

/** Midnight (Swedish time) of the day containing d, plus `days`. */
export function startOfStockholmDay(d: Date, days = 0): Date {
  const p = stockholmParts(d);
  return stockholm(p.year, p.month, p.day + days);
}

export function isOnStep(d: Date): boolean {
  return d.getTime() % (STEP_MINUTES * 60_000) === 0;
}

export function ceilToStep(d: Date): Date {
  const step = STEP_MINUTES * 60_000;
  return new Date(Math.ceil(d.getTime() / step) * step);
}

export function addMinutes(d: Date, minutes: number): Date {
  return new Date(d.getTime() + minutes * 60_000);
}
